import { useState } from "react";
import { useParams } from "wouter";
import { toast } from "sonner";
import { BellOff, CheckCircle2, Loader2, XCircle } from "lucide-react";
import { trpc } from "@/lib/trpc";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";

export default function PartnerUnsubscribe() {
  const { token } = useParams<{ token: string }>();
  const [done, setDone] = useState(false);
  const unsubscribe = trpc.partner.unsubscribeOffer.useMutation({
    onSuccess: () => {
      setDone(true);
      toast.success("You have been unsubscribed from future outreach.");
    },
    onError: error => toast.error(error.message),
  });

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-950 px-4">
      <Card className="w-full max-w-md border-slate-800 bg-slate-900">
        <CardContent className="space-y-5 p-8 text-center">
          {done ? (
            <>
              <CheckCircle2 className="mx-auto h-14 w-14 text-emerald-400" />
              <div>
                <h1 className="text-xl font-bold text-white">
                  You are unsubscribed
                </h1>
                <p className="mt-2 text-sm leading-6 text-slate-400">
                  GamePoint will suppress this contact from future AI Forge
                  outreach proposals.
                </p>
              </div>
            </>
          ) : (
            <>
              <BellOff className="mx-auto h-14 w-14 text-amber-300" />
              <div>
                <h1 className="text-xl font-bold text-white">
                  Stop future outreach?
                </h1>
                <p className="mt-2 text-sm leading-6 text-slate-400">
                  This will unsubscribe you from future GamePoint partnership
                  proposal emails. It will not change your response to this
                  specific offer.
                </p>
              </div>
              <Button
                disabled={!token || unsubscribe.isPending}
                onClick={() => unsubscribe.mutate({ token: token || "" })}
                className="w-full bg-neon text-navy hover:bg-neon/90"
              >
                {unsubscribe.isPending ? (
                  <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                ) : (
                  <XCircle className="mr-2 h-4 w-4" />
                )}
                Unsubscribe
              </Button>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
